RivalIQ.apps.Insights.module('curations', function (curations, App, Backbone, Marionette, $, _, s) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    function getMenuConfiguration(source) {
        const sourceName = _.findKey(RivalIQ.enums.sources, function (v) { return v === source; });
        return RivalIQ.configuration.menus.getConfiguration()[sourceName];
    }


    curations._BaseInsightsCuration = Dashboard.models.Curation.mixin({
        mixins: {
            Switchable: Dashboard.mixins.Switchable,
            exportHD: RivalIQ.apps.Dashboard.mixins.ExportHD,
            CurationBufferedEventProxy: Dashboard.mixins.CurationBufferedEventProxy
        },

        // NOTE: subclasses must define a source.
        source: undefined,

        formatPresence: function (currentPresence) {
            if (currentPresence) {
                const companyId = currentPresence.get('companyId');
                const company = RivalIQ.state.landscape.getCompanyById(companyId);
                return company.get('name');
            }
        },

        companySets: false,
        exportShowFocusCompany: false,
        exportShowCompany: true,
        scheduledExportAdvancedSettingsEnabled: false,

        processProps: function (props) {
            const me = this;

            // TODO clean up use of tag here
            props.tag = RivalIQ.state.companySets.none;
            props.source = me.source;
            let showPostTags = RivalIQ.settings.userSettings.showPostTags;
            if (_.isUndefined(showPostTags)) {
                showPostTags = true;
            }
            props.showPostTags = showPostTags;

            // This is necessary because the backend will override `companyId` with whatever is set for `focusCompanyId`. See #33450
            props.focusCompanyId = props.companyId;

            return props;
        },

        getExportSubtitle: function () {
            const me = this;

            const subtitleParts = [];

            const searchTerm = me.getProp('searchTerm');
            if (searchTerm) {
                subtitleParts.push(`Query: "${_.escape(searchTerm)}"`);
            }

            const mediaTypeFilter = me.getProp('mediaTypeFilter');
            if (mediaTypeFilter) {
                subtitleParts.push(`Type: ${_.escape(mediaTypeFilter)}`);
            }

            return subtitleParts;
        },

        getFilename: function () {
            const me = this;

            return RivalIQ.export.filename.base({
                title: me.getTitle(),
                landscapeName: RivalIQ.state.view.get('landscapeName'),
                companyId: me.getProp('companyId')
            });
        },

        page: function () {
            const me = this;
            const clonedPage = _.cloneDeep(getMenuConfiguration(me.source));

            if (!me.presence || me.getProp('channelRedacted')) {
                _.set(clonedPage, ['metadata', 'channelRedacted'], true);
            }

            return clonedPage;
        },

        title: function () {
            const me = this;
            return getMenuConfiguration(me.source).name;
        },

        getCurationId: function () {
            const me = this;
            return s.dasherize(`${me.id.toLowerCase()}-${me.getProp('companyId')}`);
        },

        getBasePath: function (props) {
            const me = this;
            const instanceId = me.getProp('instanceId');
            const defaults = {
                companyId: me.getProp('companyId'),
                // if we're in the details view of a widget (probably a table), prefer its searchTerm over the curation-level searchTerm
                searchTerm: instanceId ? me.getWidget(instanceId).getProp('searchTerm') : me.getProp('searchTerm')
            };
            return me.router.resolveCurationRoute(me.id, _.extend(defaults, props));
        },

        getBackPath: function (widgetProps) {
            const me = this;

            const props = _.omit(_.pick(widgetProps, App.utils.validCurationOptions), 'instanceId', 'widgetId');
            return me.getBasePath(props);
        },

        getTitle: function () {
            const me = this;

            let currentPresence = null;
            if (me.presences) {
                currentPresence = me.presences.findWhere({
                    companyId: me.getProp('companyId')
                });
            }

            const title = (me.getProp('format') ? me.getExportTitle() : me.appTitle);

            return _.compact([title, me.formatPresence(currentPresence)]).join(' / ');
        },

        titleView: function () {
            const me = this;

            if (me.presences && me.presences.length > 1) {
                return me.getSwitchableTitleView();
            }
            return me.getTitle();
        },

        saveLastSelectedInsightsPresence: function (companyId) {
            const me = this;

            const landscapeId = me.getProp('landscapeId');

            const stateKey = `lastSelected${_.upperFirst(RivalIQ.enums.sourceDetails[me.source].channel)}Companies`;

            const lastSelectedInsightsCompanies = RivalIQ.state.user.get(stateKey) || {};
            lastSelectedInsightsCompanies[landscapeId] = companyId;

            const stateUpdate = {};
            stateUpdate[stateKey] = lastSelectedInsightsCompanies;
            RivalIQ.state.user.set(stateUpdate);
        },

        parseParams: function (params) {
            const me = this;
            const parsed = RivalIQ.apps.Dashboard.models.Curation.prototype.parseParams.call(me, params);

            return RivalIQ.utils.queryParams.forceSearchParamsToString(parsed, RivalIQ.enums.searchFieldNames);
        }
    });
}, window.s);
